import { render, staticRenderFns } from "./TapCoinReactor.vue?vue&type=template&id=f4df767e&scoped=true&"
import script from "./TapCoinReactor.vue?vue&type=script&lang=js&"
export * from "./TapCoinReactor.vue?vue&type=script&lang=js&"
import style0 from "./TapCoinReactor.vue?vue&type=style&index=0&id=f4df767e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4df767e",
  null
  
)

export default component.exports